
import { defineComponent } from 'vue'
import { iDriver } from '@/modules/workspace/gisDocumentDesigner/GisDocumentDesigner'
import { filterDefault } from '@/helpers/commons/filterHelper'
import descriptor from './GisDocumentDesignerDataset&LayerDescriptor.json'
import styleDescriptor from '@/modules/workspace/gisDocumentDesigner/GisDocumentDesignerDescriptor.json'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'

const deepcopy = require('deepcopy')

export default defineComponent({
    components: {
        DataTable,
        Column,
        Dialog
    },
    emits: ['driverChanged'],
    props: { documentDataProp: { type: Object as any, required: false }, isDatasetChosen: Boolean },
    computed: {},
    data() {
        return {
            descriptor,
            styleDescriptor,
            columns: descriptor.driverColumns,
            globalFilterFields: descriptor.layerFilterFields,
            mainFilters: { global: [filterDefault] } as Object,
            singleFilters: { global: [filterDefault] } as Object,
            multipleFilters: { global: [filterDefault] } as Object,
            driverDialogVisible: false,
            selectedDriver: {} as iDriver,
            selectedDriversList: [] as iDriver[],
            documentData: {} as any
        }
    },
    created() {
        this.documentData = this.documentDataProp
        this.selectedDriversList = deepcopy(this.documentDataProp.selectedDriver)
    },

    methods: {
        closeDialog() {
            this.selectedDriver = {} as iDriver
            this.selectedDriversList = deepcopy(this.documentDataProp.selectedDriver)
            this.driverDialogVisible = false
        },
        saveLayerSelection() {
            this.$emit('driverChanged', this.selectedDriversList)
            this.driverDialogVisible = false
        },
        deleteselectedDriver(eventData) {
            this.documentData.selectedDriver.splice(eventData.index, 1)
        }
    }
})
